import ArrowDownCircleIcon from '@offerzen/zenicon/ArrowDownCircleIcon'
import ArrowUpCircleIcon from '@offerzen/zenicon/ArrowUpCircleIcon'
import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'
import CloseCircleIcon from '@offerzen/zenicon/CloseCircleIcon'
import CodeCircleIcon from '@offerzen/zenicon/CodeCircleIcon'
import ConversationIcon from '@offerzen/zenicon/ConversationIcon'
import DocumentCutIcon from '@offerzen/zenicon/DocumentCutIcon'
import HeartIcon from '@offerzen/zenicon/HeartIcon'

const InterviewRequestStatus = {
  Pending: 'pending',
  Accepted: 'accepted',
  Declined: 'declined',
  Withdrawn: 'withdrawn',
}
Object.freeze(InterviewRequestStatus)
export { InterviewRequestStatus }

export const interviewRequestStatusMap = {
  pending: {
    id: InterviewRequestStatus.Pending,
    label: 'Pending',
  },
  accepted: {
    id: InterviewRequestStatus.Accepted,
    label: 'Accepted',
  },
  declined: {
    id: InterviewRequestStatus.Declined,
    label: 'Declined',
  },
  withdrawn: {
    id: InterviewRequestStatus.Withdrawn,
    label: 'Withdrawn',
  },
}

export const interviewRequestStatusList = Object.values(interviewRequestStatusMap)

export const interviewRequestAtsStatusMap = {
  interviewing: {
    id: 'interviewing',
    label: 'Interviewing',
    icon: ConversationIcon,
  },
  technical_screening: {
    id: 'technical_screening',
    label: 'Technical screening',
    icon: CodeCircleIcon,
  },
  extending_offer: {
    id: 'extending_offer',
    label: 'Extending offer',
    icon: DocumentCutIcon,
  },
  hired: {
    id: 'hired',
    label: 'Hired',
    icon: HeartIcon,
  },
  rejected: {
    id: 'rejected',
    label: 'Rejected',
    icon: CloseCircleIcon,
  },
}

export const interviewRequestAtsStatusList = Object.values(interviewRequestAtsStatusMap)

export const competingInterviewRequestsMap = {
  higher: {
    id: 'higher',
    icon: ArrowUpCircleIcon,
  },
  equal: {
    id: 'equal',
    icon: CheckCircleIcon,
  },
  lower: {
    id: 'lower',
    icon: ArrowDownCircleIcon,
  },
}

export const messageFilterOptionsList = [
  {
    id: 'all',
    label: 'Read and unread',
  },
  {
    id: 'read',
    label: 'Read',
  },
  {
    id: 'unread',
    label: 'Unread',
  },
]
